import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=4ae2ef32&scoped=true&"
import script from "./tixian.vue?vue&type=script&lang=js&"
export * from "./tixian.vue?vue&type=script&lang=js&"
import style0 from "./tixian.vue?vue&type=style&index=0&id=4ae2ef32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2ef32",
  null
  
)

export default component.exports